import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";


export const fetch_dashboard_statistics = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch('/dashboard/get_statistics', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody.data || null,
        };
    } catch (err) {
        logger.error("Error fetching dashboard statistics:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const fetch_historical_kpis = async (period = 1) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch(`/dashboard/get_historical_kpis?period=${period}`, requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody.data || null,
        };
    } catch (err) {
        logger.error("Error fetching historical KPIs:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};
